import React, { useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody,
  ModalFooter, ModalCloseButton, Button, Select, Input, FormControl,
  FormLabel, useToast
} from '@chakra-ui/react';
import { useCognito } from '../utils/useCognito';

const presetNumbers = {
  Altera: { name: "Altera", fax: "18778141401" },
  Surgenex: { name: "Surgenex", fax: "18666788512" },
  Test: { name: "Test", fax: "12155551212" },
  Custom: { name: "", fax: "" },
};

export default function FaxModal({ isOpen, onClose, ivrId, userId, onSuccess }) {
  const [destination, setDestination] = useState("Altera");
  const [customName, setCustomName] = useState("");
  const [customFax, setCustomFax] = useState("");
  const [sending, setSending] = useState(false);
  const toast = useToast();
  const { getIdToken } = useCognito();

  const getPayload = () => {
    const isCustom = destination === "Custom";
    const preset = presetNumbers[destination];
    return {
      ivrId,
      userId,
      tofaxname: isCustom ? customName : preset.name,
      tofaxno: isCustom ? customFax : preset.fax,
      tophone: "N/A",
      test: destination === "Test"
    };
  };

  const handleSend = async () => {
    try {
      setSending(true);
      const payload = getPayload();
  
      const token = getIdToken();
  
      const res = await fetch("https://w6mxt54h5f.execute-api.us-east-2.amazonaws.com/Prod/api/sendIvrFax", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload)
      });
  
      const result = await res.json();
      if (!res.ok) throw new Error(result.error || "Fax failed");
  
      toast({ title: "Fax sent!", status: "success", duration: 3000, isClosable: true });
  
      onSuccess?.({
        tofaxname: payload.tofaxname,
        tofaxno: payload.tofaxno,
        sentAt: new Date().toISOString(),
      });
  
      onClose();
    } catch (err) {
      console.error("Fax failed:", err);
      toast({ title: "Fax failed", description: err.message, status: "error", duration: 4000, isClosable: true });
    } finally {
      setSending(false);
    }
  };  

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Fax</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl mb={3}>
            <FormLabel>Destination</FormLabel>
            <Select value={destination} onChange={(e) => setDestination(e.target.value)}>
              {Object.keys(presetNumbers).map((key) => (
                <option key={key} value={key}>
                  {key === "Custom"
                    ? "Custom (Enter Number)"
                    : `${presetNumbers[key].name} (${presetNumbers[key].fax})`}
                </option>
              ))}
            </Select>
          </FormControl>
          {destination === "Custom" && (
            <>
              <FormControl mb={3}>
                <FormLabel>Recipient Name</FormLabel>
                <Input value={customName} onChange={(e) => setCustomName(e.target.value)} />
              </FormControl>
              <FormControl mb={3}>
                <FormLabel>Fax Number</FormLabel>
                <Input value={customFax} onChange={(e) => setCustomFax(e.target.value)} />
              </FormControl>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button colorScheme="teal" ml={3} isLoading={sending} onClick={handleSend}>
            Send Fax
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
